import { useEffect, useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";

const MANAGER_EMAIL = "lqduong.dev@gmail.com";
const MANAGER_PASSWORD = "123Duong@";

export function ManagerLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("manager_auth") === "1") {
      navigate("/manager", { replace: true });
    }
  }, [navigate]);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (loading) return;
    setError(null);
    setLoading(true);
    // Artificial delay to show loading state
    await new Promise((r) => setTimeout(r, 300));
    if (email.trim() === MANAGER_EMAIL && password === MANAGER_PASSWORD) {
      localStorage.setItem("manager_auth", "1");
      navigate("/manager", { replace: true });
    } else {
      setError("Email hoặc mật khẩu không đúng.");
    }
    setLoading(false);
  };

  return (
    <main className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-body px-4">
      <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-pink-200 opacity-20 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-blue-200 opacity-20 blur-3xl" />

      <div className="relative z-10 flex w-full max-w-sm flex-col items-center">
        <Logo size={96} className="drop-shadow-2xl" />
        <h1 className="mt-4 text-3xl font-black text-gray-900">Quản lý</h1>
        <p className="mt-1 text-sm tracking-wide text-gray-500">Khu Vui Chơi Nhà Thỏ</p>

        <form
          onSubmit={submit}
          className="mt-8 w-full rounded-3xl bg-white p-8 shadow-xl ring-1 ring-pink-100"
        >
          <label htmlFor="email" className="mb-2 block text-xs font-semibold uppercase tracking-widest text-gray-600">
            Email
          </label>
          <input
            id="email"
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading}
            className="h-12 w-full rounded-2xl border-2 border-pink-200 bg-pink-50/50 px-4 text-base font-medium text-gray-900 outline-none transition duration-300 placeholder:text-gray-400 focus:border-pink-500"
            placeholder="manager@nhatho.com"
          />

          <label htmlFor="password" className="mb-2 mt-4 block text-xs font-semibold uppercase tracking-widest text-gray-600">
            Mật khẩu
          </label>
          <input
            id="password"
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={loading}
            className="h-12 w-full rounded-2xl border-2 border-pink-200 bg-pink-50/50 px-4 text-base font-medium text-gray-900 outline-none transition duration-300 placeholder:text-gray-400 focus:border-pink-500"
            placeholder="••••••••"
          />

          {error && (
            <div
              role="alert"
              className="mt-4 rounded-xl border border-rose-100 bg-rose-50 p-3 text-center text-sm font-medium text-rose-500"
            >
              ❌ {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="btn-cta mt-6 w-full drop-shadow-pink-glow"
          >
            {loading ? "Đang đăng nhập…" : "Đăng nhập"}
          </button>
        </form>
      </div>
    </main>
  );
}
